import BigTitle from './BigTitleHome';


        
const Hero = () => {


return (

<div>
  

<BigTitle title1='KETAN PATEL' title2="Designing products that solve real problems." title3='From complex platforms to new product concepts, I design systems shaped by user insight, data and real-world needs.' />


    
</div>
)


}


export default Hero;